import { render, staticRenderFns } from "./FavTabs.vue?vue&type=template&id=c56f691a"
import script from "./FavTabs.vue?vue&type=script&lang=js"
export * from "./FavTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports